import { render, staticRenderFns } from "./RevisarReservaNavidad.vue?vue&type=template&id=e5f01c20&scoped=true&"
import script from "./RevisarReservaNavidad.vue?vue&type=script&lang=ts&"
export * from "./RevisarReservaNavidad.vue?vue&type=script&lang=ts&"
import style0 from "./RevisarReservaNavidad.vue?vue&type=style&index=0&id=e5f01c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f01c20",
  null
  
)

export default component.exports